export class ActivityEvent{
    public repairOrderNumber:string;
    public repairLineNumber:string;
}